(function ($) {

  "use strict";

  new WOW.WOW({
    live: false
  }).init();

})(jQuery);


var web = {

  init: function() {
    web.register();
  },

  register: function() {
    var el = $('#register-button');

    if (! el.length) return;

    el.on('click', function() {
      $('#register').submit();
    });
  },

}

$(document).ready(function(){
  web.init();
});
